import { render, staticRenderFns } from "./platformAdvantage.vue?vue&type=template&id=6fb6aa14&scoped=true&"
import script from "./platformAdvantage.vue?vue&type=script&lang=js&"
export * from "./platformAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./platformAdvantage.vue?vue&type=style&index=0&id=6fb6aa14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6aa14",
  null
  
)

export default component.exports